import SortingVisualizer from "./SortingVisualizer/SortingVisualizer";

function App() {
  return (
    <div className="App">
      <SortingVisualizer></SortingVisualizer>
    </div>
  );
}

export default App;
